// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__2TKXE","message":"CookieConsent_message__1jWJn","cookieLink":"CookieConsent_cookieLink__2RaYL","continueBtn":"CookieConsent_continueBtn__13Dsn"};